<script lang="ts">
    import {generateMockSegmentedData, overallOptimisationOverviewJobTypeSummariesMockData} from './mock-data';
    import {priceFormatter} from 'shared/utils/pipes';
    import {getCurrentLanguage} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import KpSegmentedBarChart from 'shared/components/kp-charts/bar-chart/KpSegmentedBarChart.svelte';
    import OptimisationOverviewContainer from './components/OptimisationOverviewContainer.svelte';
    import OptimisationOverviewHeading from './components/OptimisationOverviewHeading.svelte';
    import KpBarebonesTable from 'shared/ui-widgets/table/barebones/KpBarebonesTable.svelte';
    import ColoredLabel from '../../../../../components/ColoredLabel.svelte';

    const priceFormat = priceFormatter(getCurrentLanguage());

    function getTotalReportedHours(): number {
        return overallOptimisationOverviewJobTypeSummariesMockData.reduce((total, jobTypeSummary) => total + jobTypeSummary.reportedStandardHours + jobTypeSummary.reportedOvertimeHours, 0);
    }

    function getTotalChargedHours(): number {
        return overallOptimisationOverviewJobTypeSummariesMockData.reduce((total, jobTypeSummary) => total + jobTypeSummary.chargedStandardHours + jobTypeSummary.chargedOvertimeHours, 0);
    }

    function getTotalReportedPrice(): number {
        return overallOptimisationOverviewJobTypeSummariesMockData.reduce((total, jobTypeSummary) => total + jobTypeSummary.reportedPrice.amount, 0);
    }

    function getTotalChargedPrice(): number {
        return overallOptimisationOverviewJobTypeSummariesMockData.reduce((total, jobTypeSummary) => total + jobTypeSummary.chargedPrice.amount, 0);
    }
</script>

<OptimisationOverviewContainer>
    <OptimisationOverviewHeading heading="Předávací protokol" printButtonLabel="Tisk předávacího protokolu"/>

    <KpBarebonesTable rowsTopBordered headerFooterDivided fontSize="12px">
        <tr slot="header">
            <th>Profese</th>
            <th>Vykázáno (S + P)</th>
            <th>Účtováno (S + P)</th>
            <th>Vykázané náklady</th>
            <th>Účtované náklady</th>
        </tr>

        <svelte:fragment slot="body">
            {#each overallOptimisationOverviewJobTypeSummariesMockData as jobTypeSummary}
                <tr>
                    <td>
                        <ColoredLabel label="{jobTypeSummary.name}"/>
                    </td>
                    <td>{jobTypeSummary.reportedStandardHours}h + {jobTypeSummary.reportedOvertimeHours}h</td>
                    <td>{jobTypeSummary.chargedStandardHours}h + {jobTypeSummary.chargedOvertimeHours}h</td>
                    <td>{pipe(jobTypeSummary.reportedPrice, priceFormat)}</td>
                    <td>{pipe(jobTypeSummary.chargedPrice, priceFormat)}</td>
                </tr>
            {/each}
        </svelte:fragment>

        <svelte:fragment slot="footer">
            <tr class="footer-row">
                <td></td>
                <td>{getTotalReportedHours()} hod.</td>
                <td>{getTotalChargedHours()} hod.</td>
                <td>{getTotalReportedPrice()} Kč</td>
                <td>{getTotalChargedPrice()} Kč</td>
            </tr>
        </svelte:fragment>
    </KpBarebonesTable>

    <KpSegmentedBarChart height="275px" data="{generateMockSegmentedData()}"/>
</OptimisationOverviewContainer>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .footer-row {
        font-weight: 500;
        font-size: @font-size-large;
    }
</style>